import React from 'react';
import { Divider } from '@mui/material';

import { isLoggedInUserEngineer } from '@paragon/login-tools';

import { useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function BracesContainerMenu() {
  const userIsEngineer = useAppSelector(isLoggedInUserEngineer);
  if (!userIsEngineer) return null;

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="brace" />
      <Divider />
      <ToggleLockingMenuItem type="brace" context="container" />
    </SceneMenuContent>
  );
}
